export default {
  errors: {
    UNKNOWN_ERROR: "Ha ocurrido un error inesperado. Por favor, inténtalo más tarde.",
    AUTH_BAD_AUTHENTICATION: "Autenticación inválida. Por favor, inténtalo de nuevo.",
    AUTH_ROLE_NOT_FOUND: "Rol de registro no encontrado. Contacta con soporte.",
    AUTH_USER_ALREADY_REGISTERED: "Este email ya está registrado. Prueba a iniciar sesión.",
    AUTH_USER_NOT_FOUND: "Usuario no encontrado. Por favor, revisa tu email o regístrate.",
    AUTH_BAD_INPUT_PARAMETER: "Datos de entrada inválidos. Por favor, revisa tu información.",
    AUTH_BAD_TYPE_RENDERED: "Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo.",
    AUTH_COMMON_ERROR: "Ha ocurrido un error. Por favor, inténtalo de nuevo.",
    AUTH_BAD_AUTH_CODE_TYPE: "Tipo de código de autenticación inválido.",
    AUTH_RATE_LIMIT_EXCEEDED: "Demasiadas solicitudes. Por favor, espera un momento e inténtalo de nuevo.",
    USER_NOT_AUTHENTICATED: "Tu sesión ha expirado. Por favor, inicia sesión de nuevo.",
    USER_NOT_GRANTED: "No tienes permisos para acceder a esta información.",
    USER_KYC_SESSION_NOT_FOUND: "Verificación de identidad no encontrada. Por favor, completa el proceso de KYC.",
    USER_NOT_GRANTED_TO_VIEW_INFO: "No tienes permisos para ver la información de este usuario.",
    USER_BAD_INPUT_PARAMETER: "Datos de entrada inválidos. Por favor, inténtalo de nuevo.",
    USER_BAD_TYPE_RENDERED: "Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo.",
    USER_COMMON_ERROR: "Ha ocurrido un error al cargar tu perfil. Por favor, inténtalo de nuevo.",
    unknown: "Ha ocurrido un error inesperado. Por favor, inténtalo más tarde.",
  },
  shared: {
    step: {
      credentials: "Introduce tu correo",
      verification: "Valida tu correo",
    },
    email: {
      label: "Email",
      placeholder: "tu@email.com",
    },
    button: "Continuar",
    error: {
      sendingCode: "Error al enviar el código",
    },
    verify: {
      title: "Hemos enviado un código a",
      subtitle: "Introduce el código de 6 dígitos",
      codeLabel: "Código de verificación",
      changeEmail: "Cambiar correo",
      resendCode: "Reenviar código",
      resendSuccess: "Código reenviado. Revisa tu bandeja de entrada.",
      error: {
        incompleteCode: "Por favor, completa el código de 6 dígitos",
        invalidCode: "Código inválido o expirado",
        title: "Error",
        message: "El código que has introducido no es el correcto, vuelve a intentarlo por favor.",
      },
    },
  },
  login: {
    title: "Iniciar sesión",
    votePrompt: "Inicia sesión para ver la votación",
    registerLink: "¿No tienes cuenta? Regístrate",
    verify: {
      button: "Iniciar sesión",
      infoMessage: "Solo recibirás el código si previamente te has registrado.",
      resendSuccess: "Código reenviado a tu correo. Solo lo recibirás si previamente te has registrado.",
    },
  },
  register: {
    title: "Registro",
    acceptTerms: {
      prefix: "Acepto y confirmo que he leído los",
      link: "términos y condiciones",
    },
    acceptPrivacy: {
      prefix: "Acepto y confirmo que he leído",
      link: "avisos de privacidad",
    },
    verify: {
      button: "Completar registro",
    },
  },
}
